<template>
  <div class="room-gallery">
    <!-- eslint-disable-next-line prettier/prettier -->
    <div
      class="column"
      v-for="(img, idx) in images"
      :key="idx"
      @click="imageClicked(img)"
    >
      <img :src="img.url" :alt="img.alt" class="room-image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomGallery',
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
    imageClicked(item) {
      this.$emit('selectImg', item);
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
.room-gallery {
  display: flex;

  .column {
    flex: 33.33%;
  }

  .column + .column {
    margin-left: 0.5em;
  }
}
.room-image {
  width: 100;
  transition: all 0.3s;

  // &:hover {
  //   transform: scale(1.1);
  // }
  &:hover {
    transform: translateY(-15px) scale(1.03);
  }
}
</style>
